import React, { Component } from "react";
import Icon from "../Common/Icon";
import purifyHTML from "../../utils/purifyHTML";

export default class Prices extends Component {
  render() {
    const { prices, compact = false, dienstregeling } = this.props;

    return prices.map((config) => {
      if (
        config.type === "ov-chipkaart" ||
        (config.type === "e-ticket" &&
          !(config.agencyIds || "")
            .split(";")
            .includes(dienstregeling.agencyId))
      ) {
        return null;
      }
      return (
        <Price key={JSON.stringify(config)} compact={compact} {...config} />
      );
    });
  }
}

class PriceContainer extends Component {
  render() {
    const { visible, children } = this.props;

    if (!visible) {
      return children;
    }

    return (
      <div className="container container--accent1-tint5">
        <div className="container container--center container--clearfix">
          <div className="container container--margin">{children}</div>
        </div>
      </div>
    );
  }
}

class Price extends Component {
  render() {
    const {
      compact,
      type,
      buyProductButtonText = "Kopen",
      productOptionsText = "",
      thisTripCostsText = "",
      buyProductButtonUrl = "",
      price = "",
    } = this.props;

    if (!buyProductButtonUrl) return null;

    let iconName = "";
    if (type === "e-ticket") {
      iconName = "barcode";
    } else if (type === "ov-chipkaart") {
      iconName = "ov-chip";
    }
    const className = `dienstregeling__prices ${
      compact ? "dienstregeling__prices--compact" : ""
    }`;
    return (
      <div className={className}>
        <PriceContainer visible={!compact}>
          <div className="reisadvies-price__header">
            <div className="reisadvies-price__price-header">
              {iconName ? (
                <Icon
                  iconName={iconName}
                  title={thisTripCostsText}
                  className="reisadvies-price__icon"
                />
              ) : null}
              {!compact && thisTripCostsText && (
                <span
                  className="reisadvies-price__text"
                  dangerouslySetInnerHTML={purifyHTML(thisTripCostsText)}
                />
              )}

              <span className="reisadvies-price__price">{price}</span>
            </div>
            <div className="reisadvies-price__button-wrapper">
              {compact ? null : (
                <span className="reisadvies-price__notice">
                  {productOptionsText}
                </span>
              )}
              <a
                href={buyProductButtonUrl}
                className="btn reisadvies-price__buy-btn btn--no-margin"
              >
                {buyProductButtonText}{" "}
                <Icon
                  className="btn__icon btn__icon--right"
                  iconName="arrow-right"
                />
              </a>
            </div>
          </div>
        </PriceContainer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dienstregeling/Prices.js